import * as React from "react";
import { Section } from "./Section.jsx";
import { TextCard } from "../frame/TextCard.jsx";
//import * as cls from "./Progress.module.scss";
export { ProgressSection };
/**
 * Секция учебного продукта, отображающая процесс загрузки или обработки данных.
 * @summary Секция загрузки и обработки данных.
 * @param {Object} props - Атрибуты элемента.
 * @param {React.ReactNode} [props.title=Загрузка] - Заголовок секции.
 * @param {React.ReactNode} [props.message=Подождите, выполняется загрузка данных...] - Сообщение.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ProgressSection(
  {
    title = "Загрузка",
    message = "Подождите, выполняется загрузка данных...",
  }) {
  return (
    <Section icon="loading" title={title}>
      <TextCard type="primary">
        {message}
      </TextCard>
    </Section>
  );
}